import { memo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Box, Button } from '@material-ui/core'
import DownloadIcon from 'app/components/icons/DownloadIcon'
import themesConfig from 'app/fuse-configs/themesConfig'
import { useImportCSVData } from 'app/store/importCSV'
import { exportCsv } from 'app/utilize/generate-csv'

import useStyles from './styles'
import { getTotalErrorCount } from 'app/store/importCSV/helpers'

const DownloadErrorFileBtn = () => {
  const classes = useStyles()
  const { formatMessage } = useIntl()

  const {
    data: { rows, headers },
  } = useImportCSVData()
  const errorLength = getTotalErrorCount(rows)

  const failedSubscribersCount = errorLength

  const handleExportCsvInvalidSubscribersData = () => {
    const headerCVS = headers.map(({ headerKey, label }) => {
      return {
        label: formatMessage({ id: label }),
        key: headerKey,
      }
    })

    headerCVS.push({ label: 'Errors', key: 'errors' })
    const invalidSubscribers = rows.filter(({ errors }) => errors)
    const csvData = invalidSubscribers.map(({ errors, ...rest }) => {
      const { invalidFields } = errors || {}
      const errorMessages = Object.keys(invalidFields)
        .map((key) => invalidFields[key])
        .join(',')

      return {
        ...rest,
        errors: errorMessages.replace(/"/g, `'`),
      }
    })

    exportCsv({
      headerCVS,
      dataCSV: csvData,
      fileName: 'Invalid_Subscribers',
    })
  }

  if (!failedSubscribersCount) return

  return (
    <Button
      disableRipple={true}
      variant="outlined"
      size="small"
      onClick={handleExportCsvInvalidSubscribersData}
      className={classes.downloadErrorsFileBtn}
    >
      <Box display={'flex'} component={'span'}>
        <DownloadIcon color={themesConfig.default.colors.primary} />
      </Box>

      <FormattedMessage
        id="subscribers.downloadErrorsFile.label"
        values={{ errorsCount: failedSubscribersCount }}
      />
    </Button>
  )
}

export default memo(DownloadErrorFileBtn)
